import React from 'react';

const TagsEditor = ({ formData, setFormData }) => {
  const tags = formData.tags || [];

  const handleChange = (e) => {
    const raw = e.target.value;
    const parsed = raw.split(',').map(t => t.trim()).filter(t => t);
    setFormData(prev => ({ ...prev, tags: parsed }));
  };

  const removeTag = (index) => {
    const updated = tags.filter((_, i) => i !== index);
    setFormData(prev => ({ ...prev, tags: updated }));
  };

  return (
    <div className="form-section">
      <h3>Tags</h3>
      <div className="form-group">
        <label>Tags (comma separated)</label>
        <input
          type="text"
          className="form-control"
          value={tags.join(', ')}
          onChange={handleChange}
          placeholder="AI, Machine Learning, Automation"
        />
      </div>
      {tags.length > 0 && (
        <div className="tag-pills" style={{ marginTop: '8px', display: 'flex', gap: '6px', flexWrap: 'wrap' }}>
          {tags.map((tag, idx) => (
            <span key={idx} className="tag-pill" style={{
              display: 'inline-flex', alignItems: 'center', gap: '4px',
              background: '#e9ecef', padding: '4px 10px', borderRadius: '12px',
              fontSize: '13px'
            }}>
              {tag}
              <button
                type="button"
                onClick={() => removeTag(idx)}
                style={{ border: 'none', background: 'none', cursor: 'pointer', padding: '0 2px', fontSize: '14px', lineHeight: 1 }}
                title="Remove tag"
              >
                ×
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default TagsEditor;
